import { useMemo, useState } from "react";
const useControlledState = (options) => {
  const { initialState, value: controlledValue, setValue: setControlledValue } = options;
  const isControlledMode = useMemo(() => {
    return controlledValue !== void 0 && setControlledValue !== void 0;
  }, [controlledValue, setControlledValue]);
  const [unControlledValue, setUnControlledValue] = useState(initialState);
  const value = isControlledMode ? controlledValue : unControlledValue;
  const setValue = isControlledMode ? setControlledValue : setUnControlledValue;
  return [value, setValue];
};
export {
  useControlledState as default
};
//# sourceMappingURL=useControlledState.js.map
